module.exports = __webpack_public_path__ + "static/img/2.3b369db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/2.svg
// module id = V6mK
// module chunks = 0